export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "UX/UI Focused",
  headline: "Software Developer",
  description:
    "I am a Software Developer heavily focused on user experience, and I love creating beautiful applications with the latest technologies",
  buttonLabel: "See my work!",
  imgStart: true,
  img: require("../../images/svg-3.svg").default,
  alt: "App img",
  dark: true,
  primary: true,
  darkText: false,
  redirectTo: "projects",
};

export const homeObjTwo = {
  id: "services",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Services",
  headline: "Turning Designs Into Reality",
  description:
    "I take your ideas and I turn them into real, solid and sustainable code, using only the latest technologies 😉",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-5.svg").default,
  alt: "Cellphone Image",
  dark: false,
  primary: false,
  darkText: true,
  redirectTo: "projects",
};

export const homeObjThree = {
  id: "contact",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Contact Me",
  headline: "Lets give your ideas the shape they deserve",
  description: "Send me an E-mail and lets work together!",
  buttonLabel: "Get a quote",
  imgStart: true,
  img: require("../../images/svg-2.svg").default,
  alt: "Email image",
  dark: true,
  primary: true,
  darkText: false,
  redirectTo: "contact",
};
